export default __webpack_public_path__ + "f3a000f739368075caf5511b544957a0.svg";